import React from "react";
import { Form } from "react-bootstrap";
import "./DropdownComponent.scss";

const DropdownComponent = ({
  id,
  label,
  description,
  title,
  formik,
  options,
  required,
  fromWorkflow,
  handleFormBlur,
  isEditable,
  hidden,
  defaultValue,
}) => {
  // Normalize options to ensure they have value and label properties
  const normalizedOptions = Array.isArray(options)
    ? options.map((option) =>
        typeof option === "string" ? { value: option, label: option } : option
      )
    : [];
  // Find the selected option's label
  const selectedValue = hidden ? defaultValue : formik?.values?.[id] || "";
  const selectedOption = normalizedOptions.find(
    (option) => option.value === selectedValue || option.label === selectedValue
  );
  const displayValue = selectedOption
    ? typeof selectedOption === "object"
      ? selectedOption.label
      : selectedOption
    : selectedValue || "";

  if (hidden) {
    return (
      <div className="upload-file-box">
        <label htmlFor={id}>
          <div className="heading-box">
            <h4 className="instruct-title">{title}</h4>
            {required && (
              <span style={{ color: "red", marginLeft: "4px" }}>*</span>
            )}
          </div>
        </label>
        <div className="mb-2 description">{description}</div>
      </div>
    );
  }

  return (
    <div className="upload-file-box">
      <label htmlFor={id}>
        <div className="heading-box">
          <h4 className="instruct-title">{title}</h4>
        </div>
      </label>
      {required && <span style={{ color: "red", marginLeft: "4px" }}>*</span>}
      <div className="mb-2 description">{description}</div>
      <Form.Control
        as="select"
        id={id}
        name={id}
        className="form-select mb-2"
        disabled={!isEditable}
        onChange={(e) => {
          formik.handleChange(e);
          if (fromWorkflow && typeof handleFormBlur === "function") {
            handleFormBlur(e);
          }
        }}
        value={formik?.values[id] || ""}
      >
        <option value="">Select an option</option>
        {Array.isArray(options) &&
          options?.map((option, index) => (
            <option key={index} value={option.value}>
              {option.label}
            </option>
          ))}
      </Form.Control>
      {formik.errors[id] && <div className="error">{formik.errors[id]}</div>}
    </div>
  );
};

export default DropdownComponent;
